import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import {
  request,
  ConfigService,
  type RequestOptions,
  type HttpAugments,
  type NextgenApiError,
} from '@nextgen-web-framework/core';

import { Language, Locale } from '../types';
import { AdditionalRequestOptions, ErrorResponse } from '../services';

const { EN, TH, ES } = Language;
const { EN_US, TH_TH, ES_CO } = Locale;
export const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const toLocalDate = (date: string | Date) => {
  const { NEXT_PUBLIC_TIMEZONE } = ConfigService.getConfigs();
  return new Date(utcToZonedTime(date, NEXT_PUBLIC_TIMEZONE as string));
};

export const toCustomDate = (date: Date) => {
  const { NEXT_PUBLIC_TIMEZONE } = ConfigService.getConfigs();
  return zonedTimeToUtc(date, NEXT_PUBLIC_TIMEZONE as string);
};

export const formatDate = (date: string | Date, isConversionRequired = true, isClient = false) => {
  const dateAtt = isConversionRequired ? toLocalDate(date) : new Date(date);
  const formatedDate = `${String(dateAtt.getDate())} ${monthNames[dateAtt.getMonth()]}${isClient ? '' : ','} ${String(
    dateAtt.getFullYear(),
  )}`;

  return `${formatedDate}, ${new Date(dateAtt.getTime()).toLocaleTimeString(navigator.language, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })}`;
};

export const getDateWithoutTime = (date: Date | string) => {
  const dateObj = new Date(date);
  dateObj.setHours(0, 0, 0, 0);
  return dateObj;
};

export const languagesByLocale = {
  [EN_US]: EN,
  [TH_TH]: TH,
  [ES_CO]: ES,
};

export const handleRequest = async <T>(
  req: RequestOptions,
  options?: AdditionalRequestOptions,
  augments?: HttpAugments,
): Promise<T> => {
  const { baseUrl, headers } = options ?? {};
  const response: T = await request(
    {
      ...req,
      ...(baseUrl && { url: `${baseUrl}${req.url}` }),
      ...(headers && { headers }),
    },
    augments ?? {
      skipIdempotency: true,
    },
  );
  return Promise.resolve(response);
};

export const getApiErrorMessage = (e: unknown) => {
  const responseBody = (e as NextgenApiError)?.responseBody as ErrorResponse;
  const message = responseBody?.subDetails?.[0]?.message || responseBody?.detail;
  return message;
};

export const syncDelay = (time: number) => new Promise<void>((r) => setTimeout(() => r(), time));
